import { useSettingsStore } from "@/stores/settings";

export default {
  sortDriveItems(driveItems, orderByProperty, orderByDirection) {
    if (driveItems == null) {
      return [];
    }

    const settingsStore = useSettingsStore();

    const sortedList = driveItems?.map(di => {
      if (di.clone) {
        return di.clone;
      } else {
        return JSON.parse(JSON.stringify(di));
      }
    });

    const folders = sortedList.filter(t => (t.folder || t.isFolder) && !t.package);
    const documents = sortedList.filter(t => !((t.folder || t.isFolder) && !t.package));
    switch (orderByProperty) {
      case "kind":
        folders.sort((a, b) => a.extension.name.localeCompare(b.extension.name, settingsStore.language));
        documents.sort((a, b) => a.extension.name.localeCompare(b.extension.name, settingsStore.language));
        break;

      case "modifieddate":
        folders.sort((a, b) => new Date(b.lastModifiedDateTime) - new Date(a.lastModifiedDateTime));
        documents.sort((a, b) => new Date(b.lastModifiedDateTime) - new Date(a.lastModifiedDateTime));
        break;

      case "createddate":
        folders.sort((a, b) => new Date(b.createdDateTime) - new Date(a.createdDateTime));
        documents.sort((a, b) => new Date(b.createdDateTime) - new Date(a.createdDateTime));
        break;

      case "modifiedby":
        folders.sort((a, b) =>
          a.lastModifiedBy?.user?.displayName.localeCompare(b.lastModifiedBy?.user?.displayName, settingsStore.language)
        );
        documents.sort((a, b) =>
          a.lastModifiedBy?.user?.displayName.localeCompare(b.lastModifiedBy?.user?.displayName, settingsStore.language)
        );
        break;

      default:
        folders.sort((a, b) => a.name.localeCompare(b.name, settingsStore.language));
        documents.sort((a, b) => a.name.localeCompare(b.name, settingsStore.language));
        break;
    }

    if (orderByDirection === "desc") {
      return [...documents.reverse(), ...folders.reverse()];
    }
    return [...folders, ...documents];
  },

  driveItemFromUrl(url) {
    const regex = /drives\/([\s\S\d\D]*?)\/items\/([\s\S\d\D]*?)$/gm;

    const groups = regex.exec(url);

    if (groups && groups.length === 3) {
      return {
        id: groups[2],
        parentReference: {
          driveId: groups[1]
        }
      };
    }
    return null;
  },

  getDriveItemDriveId: item => {
    return item.remoteItem ? item.remoteItem.parentReference.driveId : item.parentReference.driveId;
  },

  getDriveId: item => {
    return item.remoteItem ? item.remoteItem.parentReference.driveId : item.parentReference.driveId;
  },

  getItemId: itemId => {
    if (!itemId) {
      return import.meta.env.VITE_BUILD_TARGET === "kkfiler" ? "0" : "root";
    }
    return itemId;
  },

  calcNewCopyName: originalName => {
    if (!originalName) {
      return originalName;
    }

    const splitSuffix = /(\((\d+)\))?(?:\.([^.]+))?$/; // https://regex101.com/r/fUd7Wl/1
    const completeSuffix = /\.[^/.]+$/; // https://regex101.com/r/qBC7pI/1

    let check = splitSuffix.exec(originalName);
    let suffix = check[3] !== undefined ? `.${check[3].toLocaleLowerCase()}` : "";

    if (check[2]) {
      const nextCopyNumber = check[2] * 1 + 1;
      return (
        originalName.replace(" - copy", "").replace(check[1], "").replace(completeSuffix, "") +
        " - copy (" +
        nextCopyNumber +
        ")" +
        suffix
      );
    } else {
      if (originalName.indexOf(" - copy" + suffix) > -1) {
        return originalName.replace(completeSuffix, "") + " (1)" + suffix;
      } else {
        return originalName.replace(completeSuffix, "") + " - copy" + suffix;
      }
    }
  },

  calcNextVersionName: originalName => {
    if (!originalName) {
      return originalName;
    }

    const splitSuffix = /(v(\d+))?(?:\.([^.]+))?$/; // https://regex101.com/r/fUd7Wl/1
    const completeSuffix = /\.[^/.]+$/; // https://regex101.com/r/qBC7pI/1

    let check = splitSuffix.exec(originalName);
    let suffix = check[3] !== undefined ? `.${check[3].toLocaleLowerCase()}` : "";

    if (check[2]) {
      const nextCopyNumber = check[2] * 1 + 1;
      return (
        //originalName.replace("", "").replace(check[1], "").replace(completeSuffix, "") +
        originalName.replace(" " + check[1], "").replace(completeSuffix, "") + " v" + nextCopyNumber + suffix
      );
    } else {
      return originalName.replace(completeSuffix, "") + " v1" + suffix;
    }
  }
};

/**
 * Calculated if documentname contains invalid characters
 * @param { string } documentName Name to check against validation
 * @returns { string } Invalid characters or null
 */
export function documentNameInvalidCharactersList(documentName) {
  return documentName.match(/["*:<>?/\\|]/);
}
